import type { ButtonHTMLAttributes } from 'react';

/**
 * A reusable button component for pagination controls.
 *
 * This component wraps a native `<button>` element and accepts all standard
 * button HTML attributes. It is intended to be used as a page navigation button.
 *
 * @param props - Standard button HTML attributes and children to display inside the button.
 * @returns A button element with the provided children and props.
 */
export const PageButton = ({ children, ...props }: ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <button
      {...props}
      type="button">
      {children}
    </button>
  );
};
